import type { Data } from 'stores/builder/field/types';

import { setCurrentFieldsEvent } from 'stores/builder/field/model';
import { FieldTypesEnum } from 'constants/builder/enums';
import { v4 as generateId } from 'uuid';

import type { FieldItem } from '../SelectMultiSelectRadioEditor';

export const createMultiselectField = (
    multiSelectItems: FieldItem[],
    selectedField: undefined | Data,
    currentFields: Data[],
    question: string,
    description: string,
    placeholder: string,
    contentId: string,
    existingFieldId?: string
) => {
    const generatedMultiSelectItems = multiSelectItems.map(item => ({
        value: item.value,
        id: generateId(),
        text: item.text,
        type: 'Text'
    }));

    setCurrentFieldsEvent(
        selectedField
            ? {
                  currentFields: currentFields.map(item =>
                      item.id === selectedField.id
                          ? {
                                multiSelectItems: generatedMultiSelectItems,
                                type: FieldTypesEnum.MultiSelect,
                                description,
                                placeholder,
                                value: '',
                                contentId,
                                question,
                                id: ''
                            }
                          : item
                  ),
                  contentId
              }
            : {
                  currentFields: [
                      ...currentFields,
                      {
                          multiSelectItems: generatedMultiSelectItems,
                          type: FieldTypesEnum.MultiSelect,
                          id: existingFieldId || '',
                          description,
                          placeholder,
                          value: '',
                          contentId,
                          question
                      }
                  ],
                  contentId
              }
    );
};
